import { Immutable } from "immer";
import React from "react";

import type { FooterBlock as FooterBlockValue } from "@reactivated";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: FooterBlockValue }>;

const unwrapRichText = (value: string | null | undefined): string => {
    return (value ?? "").replace(/class=.rich-text./g, "");
};

const hasVisibleContent = (value: string): boolean => {
    const textContent = value
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, "")
        .trim();

    return (
        textContent.length > 0 ||
        /<(img|iframe|ol|picture|svg|table|ul|video)\b/i.test(value)
    );
};

export const CocoonFooterBlock = (props: IProps): React.JSX.Element | null => {
    const copy = unwrapRichText(props.value.copy);

    if (!hasVisibleContent(copy)) {
        return null;
    }

    return (
        <div className={styles.finePrintContainer}>
            <div
                className={styles.finePrintBlock}
                dangerouslySetInnerHTML={{
                    __html: copy,
                }}
            ></div>
        </div>
    );
};
